export const AdminExams = ({ color = "currentColor" }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 5H21" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13 9H18" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13 15H21" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13 19H18" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3 6.59961L5.25 8.84961L9 5.09961" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.7 14.7002L6 17.4002M3.3 20.1002L6 17.4002M6 17.4002L3.3 14.7002M6 17.4002L8.7 20.1002" stroke={color} stroke-width="2" stroke-linecap="round" />
        </svg>
    )
}